export enum BalooSyncLogItemType {
    NoChanges,
    BalooCreated,
    BalooUpdated,
    BalooAddedToGroup,
    BalooRemovedFromGroup,
    BalooReactivated,
    BalooDeactivated,
    Error = 200,
}
